import React, { useEffect, useState, useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Box,
  Button,
  Skeleton,
  // Chip,
  ListItemIcon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
  Collapse,
  Alert,
  Autocomplete,
} from '@mui/material';
// import Header from '../landingPage/Header';
import Sidebar from '../landingPage/Sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { fetchAllConnections, deleteConnection } from '../../apis/Connections';
// import useLogout from '../../hooks/useLogout';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import salesForce from '../../workflows/images/salesforce.png';
import mySql from '../../workflows/images/sql.png';
import oracle from '../../workflows/images/oracle.png';
import Jira from '../../workflows/images/JIRA.svg';
import hubspot from '../../workflows/images/hubspot.png';
import github from '../../workflows/images/github.png';
import EditIcon from '../../Images/Edit.png';
import DeleteIcon from '../../Images/Delete.png';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import SearchIcon from '@mui/icons-material/Search';
import CloseRounded from '@mui/icons-material/CloseRounded';
import Fade from '@mui/material/Fade';
// import LanOutlined from '@mui/icons-material/LanOutlined';
import KeyboardArrowDownRounded from '@mui/icons-material/KeyboardArrowDownRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import DeleteConnectionDialog from './DeleteConnectionDialog';
import EditConnectionReauthDialog from './EditConnectionReauthDialog';
import Connector from '../landingPage/Connector';
import connectorIcon from '../../workflows/images/ConnectorIcon.png';
import { useTimezone } from '../../hooks/useTimezone';
import Cookies from 'js-cookie';

const MyConnections = () => {
  const navigate = useNavigate();
  const { formatDate } = useTimezone();

  const location = useLocation();

  const initialMsg = location.state?.errorMessage || null;
  const [pageError, setPageError] = useState(initialMsg);

  const [connections, setConnections] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [search, setSearch] = useState('');
  // const handleLogout = useLogout();
  const [loading, setLoading] = useState(true);
  const [selectedConnector, setSelectedConnector] = useState('all');
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedEnvironment, setSelectedEnvironment] = useState('all');
  const [selectedCreatedAt, setSelectedCreatedAt] = useState('all');
  const [customDateRange, setCustomDateRange] = useState({
    start: '',
    end: '',
  });
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [editReauthOpen, setEditReauthOpen] = useState(false);
  const [pendingEdit, setPendingEdit] = useState(null);

  // Simple sorting state - for all sortable columns
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: 'none',
  });

  const rawRole = Cookies.get('Role_id') ?? Cookies.get('role_id');
  const isSuperAdmin = useMemo(() => {
    const n = Number(rawRole);
    return !Number.isNaN(n) && n === 1;
  }, [rawRole]);
  const isAdmin = useMemo(() => {
    const n = Number(rawRole);
    return !Number.isNaN(n) && n === 2;
  }, [rawRole]);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  const hubspotCode = params.get("code");
  let rawState = params.get("state");

  let selectedConnectionId = null;

  if (rawState) {
    try {
      // 1️⃣ Decode URI
      let decoded = decodeURIComponent(rawState);

      // 2️⃣ FIX the invalid JSON by removing '+' characters
      decoded = decoded.replace(/\+/g, "");

      console.log("🔍 Cleaned state:", decoded);

      // 3️⃣ Parse JSON
      const parsed = JSON.parse(decoded);

      selectedConnectionId = parsed.conn_id;
      console.log("🔗 Final Connection ID:", selectedConnectionId);

    } catch (err) {
      console.error("❌ Error parsing state:", err);
    }
  }

  if (hubspotCode) {
    console.log("✅ HubSpot OAuth code received:", hubspotCode);

    fetch("https://hmetl.hyperminds.tech/api/v1/oauth/hubspot/callback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        code: hubspotCode,
        conn_id: selectedConnectionId,
      }),
    })
      .then(async (res) => {
        console.log("⬅️ Response status:", res.status);
        const data = await res.json();
        console.log("✅ HubSpot tokens stored successfully:", data);
      })
      .catch((err) => console.error("❌ Error during HubSpot callback:", err));
  }
}, []);

  useEffect(() => {
    if (initialMsg) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [initialMsg, navigate, location.pathname]);

  useEffect(() => {
    const loadConnections = async () => {
      setLoading(true);
      try {
        const result = await fetchAllConnections();
        const formatted = result
          .map((conn) => {
            const ts = conn.created_dt
              ? new Date(conn.created_dt).getTime()
              : 0;
            return {
              id: conn.conn_id,
              name: conn.conn_name,
              apiVersion: conn.api_version,
              createdAt: Number.isFinite(ts) ? ts : 0, // used for sorting
              createdDate: conn.created_dt
                ? formatDate(conn.created_dt, { includeTime: true })
                : 'N/A',
              connector: conn.connector_name,
              environment: conn.environment || 'N/A',
              userName: conn.user_name || null,
              orgName: conn.org_name || null,
            };
          })
          // default sort: newest first
          .sort((a, b) => b.createdAt - a.createdAt);

        setConnections(formatted);
      } catch (error) {
        console.error('Error loading connections:', error);
        setConnections([]);
        toast.error('Failed to load connections. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    loadConnections();
  }, [formatDate]);

  // Universal sort handler for all columns
  const handleSort = (column) => {
    let direction = 'asc';

    if (sortConfig.column === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    } else if (
      sortConfig.column === column &&
      sortConfig.direction === 'desc'
    ) {
      direction = 'none';
      column = null;
    }

    setSortConfig({ column, direction });
  };

  const handleDelete = async (id) => {
    try {
      await deleteConnection(id);
      setConnections((prev) => prev.filter((conn) => conn.id !== id));
      toast.success('Connection deleted', { autoClose: 1500 });
    } catch (error) {
      toast.error('Failed to delete connection');
      console.error(error);
    }
  };

  // Animation variants from FlowExecution
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4,
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  const rowVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.05,
        duration: 0.3,
        ease: 'easeOut',
      },
    }),
  };

  // Get unique connectors for filter options
  const uniqueConnectors = [
    ...new Set(connections.map((conn) => conn.connector)),
  ].filter(Boolean);

  // Get unique owners and organizations for filter options
  const uniqueOwners = useMemo(() => {
    const owners = connections
      .map((conn) => conn.userName)
      .filter(Boolean)
      .filter((name) => name !== 'N/A');
    return [...new Set(owners)].sort();
  }, [connections]);

  const uniqueOrganizations = useMemo(() => {
    const orgs = connections
      .map((conn) => conn.orgName)
      .filter(Boolean)
      .filter((name) => name !== 'N/A');
    return [...new Set(orgs)].sort();
  }, [connections]);

  const uniqueEnvironments = useMemo(() => {
    const envs = connections.map((conn) => conn.environment).filter(Boolean);
    return [...new Set(envs)].sort();
  }, [connections]);

  // Helper function to check if date is within range
  const isDateInRange = (timestamp, range) => {
    if (range === 'all') return true;
    if (!timestamp) return false;

    const now = new Date();
    const connDate = new Date(timestamp);

    // Get today's start and end
    const todayStart = new Date(now);
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date(now);
    todayEnd.setHours(23, 59, 59, 999);

    switch (range) {
      case 'today':
        return connDate >= todayStart && connDate <= todayEnd;
      case 'last7days': {
        const sevenDaysAgo = new Date(todayStart);
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        return connDate >= sevenDaysAgo && connDate <= todayEnd;
      }
      case 'last30days': {
        const thirtyDaysAgo = new Date(todayStart);
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        return connDate >= thirtyDaysAgo && connDate <= todayEnd;
      }
      case 'last90days': {
        const ninetyDaysAgo = new Date(todayStart);
        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
        return connDate >= ninetyDaysAgo && connDate <= todayEnd;
      }
      case 'custom': {
        if (!customDateRange.start || !customDateRange.end) return true;
        const startDate = new Date(customDateRange.start);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(customDateRange.end);
        endDate.setHours(23, 59, 59, 999);
        return connDate >= startDate && connDate <= endDate;
      }
      default:
        return true;
    }
  };

  // Filter connections based on all selected filters
  const filteredConnections = useMemo(() => {
    let filtered = connections;

    // Filter by connector
    if (selectedConnector !== 'all') {
      filtered = filtered.filter((conn) =>
        conn.connector?.toLowerCase().includes(selectedConnector.toLowerCase()),
      );
    }

    // Filter by owner
    if (selectedOwner) {
      filtered = filtered.filter((conn) => conn.userName === selectedOwner);
    }

    // Filter by organization
    if (selectedOrganization) {
      filtered = filtered.filter(
        (conn) => conn.orgName === selectedOrganization,
      );
    }

    // Filter by environment
    if (selectedEnvironment !== 'all') {
      filtered = filtered.filter(
        (conn) => conn.environment === selectedEnvironment,
      );
    }

    // Filter by created at
    if (selectedCreatedAt !== 'all') {
      filtered = filtered.filter((conn) =>
        isDateInRange(conn.createdAt, selectedCreatedAt),
      );
    }

    return filtered;
  }, [
    connections,
    selectedConnector,
    selectedOwner,
    selectedOrganization,
    selectedEnvironment,
    selectedCreatedAt,
    customDateRange,
  ]);

  // Search and sort the filtered connections
  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    let filtered = filteredConnections;

    if (q) {
      filtered = filteredConnections.filter(
        (r) =>
          r?.name?.toLowerCase().includes(q) || // connection name
          r?.connector?.toLowerCase().includes(q) ||
          r?.userName?.toLowerCase().includes(q) ||
          r?.orgName?.toLowerCase().includes(q),
      );
    }

    // Apply sorting to all sortable columns
    if (sortConfig.direction !== 'none' && sortConfig.column) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.column) {
          case 'name':
            aValue = (a.name || '').toLowerCase();
            bValue = (b.name || '').toLowerCase();
            break;
          case 'environment':
            aValue = (a.environment || '').toLowerCase();
            bValue = (b.environment || '').toLowerCase();
            break;
          case 'createdAt':
            aValue = a.createdAt || 0;
            bValue = b.createdAt || 0;
            break;
          case 'userName':
            aValue = (a.userName || '').toLowerCase();
            bValue = (b.userName || '').toLowerCase();
            break;
          case 'orgName':
            aValue = (a.orgName || '').toLowerCase();
            bValue = (b.orgName || '').toLowerCase();
            break;
          case 'connector':
            aValue = (a.connector || '').toLowerCase();
            bValue = (b.connector || '').toLowerCase();
            break;
          default:
            return 0;
        }

        if (sortConfig.column === 'createdAt') {
          // For dates, higher timestamp = more recent
          return sortConfig.direction === 'asc'
            ? aValue - bValue
            : bValue - aValue;
        } else {
          // For strings, alphabetical
          if (sortConfig.direction === 'asc') {
            return aValue.localeCompare(bValue);
          } else {
            return bValue.localeCompare(aValue);
          }
        }
      });
    }

    return filtered;
  }, [filteredConnections, search, sortConfig]);

  const displayedRows = showAll ? filteredRows : filteredRows.slice(0, 10);

  // Handle filter changes
  const handleConnectorFilterChange = (event) => {
    setSelectedConnector(event.target.value);
    setShowAll(false);
  };

  const handleEnvironmentFilterChange = (event) => {
    setSelectedEnvironment(event.target.value);
    setShowAll(false);
  };

  const handleCreatedAtFilterChange = (event) => {
    setSelectedCreatedAt(event.target.value);
    setShowAll(false);
  };

  const handleOwnerChange = (_, newValue) => {
    setSelectedOwner(newValue);
    setShowAll(false);
  };

  const handleOrganizationChange = (_, newValue) => {
    setSelectedOrganization(newValue);
    setShowAll(false);
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSelectedConnector('all');
    setSelectedOwner(null);
    setSelectedOrganization(null);
    setSelectedEnvironment('all');
    setSelectedCreatedAt('all');
    setCustomDateRange({ start: '', end: '' });
    setShowAll(false);
  };

  // Clear filter
  // const clearFilter = () => {
  //   setSelectedConnector('all');
  // };

  if (!loading && connections.length === 1) {
    return (
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          bgcolor: '#f8fafc',
          minHeight: '100vh',
        }}
      >
        <Box sx={{ flexGrow: 1, px: 3, py: 2 }}>
          <Collapse in={!!pageError} unmountOnExit>
            <Alert
              severity="error"
              onClose={() => setPageError(null)}
              sx={{
                mb: 2,
                border: '1px solid #fecaca',
                background: '#fee2e2',
                color: '#7f1d1d',
              }}
            >
              {pageError}
            </Alert>
          </Collapse>

          {/* When there are 0 connections after fetch, show Connector page */}
          <Connector />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        bgcolor: '#f8fafc',
        minHeight: '100vh',
      }}
    >
      {/* <Header handleLogout={handleLogout} /> */}
      <Sidebar />

      <Box sx={{ flexGrow: 1, px: 3, py: 2 }}>
        <Collapse in={!!pageError} unmountOnExit>
          <Alert
            severity="error"
            onClose={() => setPageError(null)}
            sx={{
              mb: 2,
              border: '1px solid #fecaca',
              background: '#fee2e2',
              color: '#7f1d1d',
            }}
          >
            {pageError}
          </Alert>
        </Collapse>

        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2,
            gap: 2,
            flexWrap: 'wrap', // responsive: wraps on small screens
          }}
        >
          {/* Left: Heading */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#0f172a',
              letterSpacing: '0.02em',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            My Connections
          </Typography>

          {/* Right: Connector icon + Add button */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2.5,
            }}
          >
            <Tooltip title="Show Connectors">
              <Box
                onClick={() => navigate('/connector')}
                sx={{
                  borderRadius: '999px',
                  p: 0.75,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition:
                    'transform 180ms cubic-bezier(.2,.8,.2,1), box-shadow 200ms ease, background-color 180ms ease',
                  backgroundColor: 'rgba(89,101,166,0.06)',
                  '&:hover': {
                    backgroundColor: 'rgba(89,101,166,0.12)',
                    transform: 'translateY(-1px) scale(1.05)',
                    boxShadow: '0 8px 18px rgba(89,101,166,0.35)',
                  },
                  '&:active': {
                    transform: 'scale(0.97)',
                    boxShadow: '0 4px 10px rgba(15,23,42,0.18)',
                  },
                }}
              >
                <Box
                  component="img"
                  src={connectorIcon}
                  alt="Connectors"
                  sx={{ width: 28, height: 28, display: 'block' }}
                />
              </Box>
            </Tooltip>

            {/* Add Connection Button (unchanged functionality) */}
            <motion.div whileTap={{ scale: 0.98 }}>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => navigate('/createconnections')}
                disableElevation
                sx={{
                  fontSize: '0.875rem',
                  backgroundColor: '#5965A6',
                  padding: '6px 14px',
                  color: 'white',
                  textTransform: 'none',
                  borderRadius: '6px',
                  fontWeight: 500,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                  transition:
                    'transform 180ms cubic-bezier(.2,.8,.2,1), box-shadow 200ms ease',
                  willChange: 'transform, box-shadow',
                  '&:hover': {
                    backgroundColor: '#5965A6',
                    transform: 'translateY(-1px) scale(1.02)',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.16)',
                  },
                  '&:active': {
                    transform: 'translateY(0) scale(0.99)',
                    boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                    boxShadow: '0 0 0 3px rgba(89,101,166,0.35)',
                  },
                }}
              >
                Add New
              </Button>
            </motion.div>
          </Box>
        </Box>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Box
            component={motion.div}
            sx={{
              borderRadius: '12px',
              background: '#ffffff',
              border: '1px solid #E5E7EB',
              p: 0,
              mt: 1,
              mb: 2,
              position: 'relative',
              overflow: 'hidden',
              boxShadow:
                '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
            }}
          >
            {/* Header */}
            <motion.div variants={itemVariants}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#ffffff',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    width: '100%',
                  }}
                >
                  {/* Title */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        color: '#111827',
                        mb: 0,
                      }}
                    >
                      Existing Connections
                    </Typography>
                  </Box>

                  {/* Filters Row - All filters, search, and View All in same row */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      gap: 2,
                      justifyContent: 'space-between',
                    }}
                  >
                    {/* Left side: All filters */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 2,
                        flex: 1,
                      }}
                    >
                      {/* Connector Filter */}
                      <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel sx={{ fontSize: '0.875rem' }}>
                          Filter by Connector
                        </InputLabel>
                        <Select
                          value={selectedConnector}
                          onChange={handleConnectorFilterChange}
                          label="Filter by Connector"
                          IconComponent={KeyboardArrowDownRounded}
                          MenuProps={{
                            TransitionComponent: Fade,
                            PaperProps: {
                              sx: {
                                mt: 0.5,
                                borderRadius: '10px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
                                overflow: 'hidden',
                              },
                            },
                            MenuListProps: { dense: true, sx: { py: 0.5 } },
                          }}
                          sx={{
                            fontSize: '0.875rem',
                            borderRadius: '10px',
                            bgcolor: '#fff',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#e2e8f0',
                              transition:
                                'border-color .2s ease, box-shadow .2s ease',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#5965A6',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#8E98CD',
                              boxShadow: '0 0 0 2px rgba(89,101,166,0.14)',
                            },
                            '& .MuiSelect-select': {
                              py: 0.75,
                              px: 1.25,
                              fontSize: '0.75rem',
                            },
                            '& .MuiSelect-icon': {
                              color: '#94a3b8',
                              transition: 'transform .2s ease',
                            },
                            '&.Mui-expanded .MuiSelect-icon': {
                              transform: 'rotate(180deg)',
                            },
                            transition:
                              'box-shadow .2s ease, background-color .2s ease, border-color .2s ease',
                          }}
                        >
                          <MenuItem
                            value="all"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedConnector === 'all'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            All Connectors
                          </MenuItem>
                          {uniqueConnectors.map((connector) => (
                            <MenuItem
                              key={connector}
                              value={connector}
                              sx={{
                                fontSize: '0.875rem',
                                px: 1.25,
                                py: 0.75,
                                transition: 'background-color .15s ease',
                                '&:hover': { backgroundColor: '#F3F6FF' },
                                '&.Mui-selected, &.Mui-selected:hover': {
                                  backgroundColor: '#EEF2FF',
                                  color: '#5965A6',
                                  fontWeight: 600,
                                },
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 24,
                                  color: '#5965A6',
                                  visibility:
                                    selectedConnector === connector
                                      ? 'visible'
                                      : 'hidden',
                                }}
                              >
                                <CheckRounded fontSize="small" />
                              </ListItemIcon>
                              {connector}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Owner Filter - Autocomplete */}
                      {(isAdmin || isSuperAdmin) && (
                        <Autocomplete
                          size="small"
                          options={uniqueOwners}
                          value={selectedOwner}
                          onChange={handleOwnerChange}
                          popupIcon={<KeyboardArrowDownRounded />}
                          sx={{
                            minWidth: 180,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',
                              bgcolor: '#fff',
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#e2e8f0',
                                transition:
                                  'border-color .2s ease, box-shadow .2s ease',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#5965A6',
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                {
                                  borderColor: '#8E98CD',
                                  boxShadow: '0 0 0 2px rgba(89,101,166,0.14)',
                                },
                              '& .MuiInputBase-input': {
                                py: 0.75,
                                px: 1.25,
                                fontSize: '0.75rem',
                              },
                              '& .MuiAutocomplete-endAdornment': {
                                '& .MuiSvgIcon-root': {
                                  color: '#94a3b8',
                                  transition: 'transform .2s ease',
                                },
                              },
                              '&.Mui-expanded .MuiAutocomplete-endAdornment .MuiSvgIcon-root':
                                {
                                  transform: 'rotate(180deg)',
                                },
                              transition:
                                'box-shadow .2s ease, background-color .2s ease, border-color .2s ease',
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Filter by Owner"
                              placeholder="All Owners"
                              InputLabelProps={{
                                shrink: true,
                                sx: { fontSize: '0.875rem' },
                              }}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '10px',
                                  height: 36,
                                  fontSize: '0.75rem',
                                },
                                '& .MuiInputBase-input': {
                                  padding: '6px 10px',
                                  color: '#0F172A',
                                },
                                '& .MuiInputBase-input::placeholder': {
                                  color: '#0F172A',
                                  opacity: 1,
                                },
                              }}
                            />
                          )}
                          PaperComponent={({ children, ...other }) => (
                            <Box
                              component="div"
                              {...other}
                              sx={{
                                borderRadius: '10px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
                                mt: 0.5,
                                overflow: 'hidden',
                              }}
                            >
                              {children}
                            </Box>
                          )}
                          ListboxProps={{
                            sx: {
                              py: 0.5,
                              '& .MuiAutocomplete-option': {
                                fontSize: '0.875rem',
                                px: 1.25,
                                py: 0.75,
                                transition: 'background-color .15s ease',
                                '&:hover': { backgroundColor: '#F3F6FF' },
                                '&.Mui-focused': { backgroundColor: '#F3F6FF' },
                              },
                            },
                          }}
                        />
                      )}

                      {/* Organization Filter - Autocomplete */}
                      {isSuperAdmin && (
                        <Autocomplete
                          size="small"
                          options={uniqueOrganizations}
                          value={selectedOrganization}
                          onChange={handleOrganizationChange}
                          popupIcon={<KeyboardArrowDownRounded />}
                          sx={{
                            minWidth: 180,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',
                              bgcolor: '#fff',
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#e2e8f0',
                                transition:
                                  'border-color .2s ease, box-shadow .2s ease',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#5965A6',
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                {
                                  borderColor: '#8E98CD',
                                  boxShadow: '0 0 0 2px rgba(89,101,166,0.14)',
                                },
                              '& .MuiInputBase-input': {
                                py: 0.75,
                                px: 1.25,
                                fontSize: '0.75rem',
                              },
                              '& .MuiAutocomplete-endAdornment': {
                                '& .MuiSvgIcon-root': {
                                  color: '#94a3b8',
                                  transition: 'transform .2s ease',
                                },
                              },
                              '&.Mui-expanded .MuiAutocomplete-endAdornment .MuiSvgIcon-root':
                                {
                                  transform: 'rotate(180deg)',
                                },
                              transition:
                                'box-shadow .2s ease, background-color .2s ease, border-color .2s ease',
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Filter by Organization"
                              placeholder="All Organizations"
                              InputLabelProps={{
                                shrink: true,
                                sx: { fontSize: '0.875rem' },
                              }}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '10px',
                                  height: 36,
                                  fontSize: '0.75rem',
                                },
                                '& .MuiInputBase-input': {
                                  padding: '6px 10px',
                                  color: '#0F172A',
                                },
                                '& .MuiInputBase-input::placeholder': {
                                  color: '#0F172A',
                                  opacity: 1,
                                },
                              }}
                            />
                          )}
                          PaperComponent={({ children, ...other }) => (
                            <Box
                              component="div"
                              {...other}
                              sx={{
                                borderRadius: '10px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
                                mt: 0.5,
                                overflow: 'hidden',
                              }}
                            >
                              {children}
                            </Box>
                          )}
                          ListboxProps={{
                            sx: {
                              py: 0.5,
                              '& .MuiAutocomplete-option': {
                                fontSize: '0.875rem',
                                px: 1.25,
                                py: 0.75,
                                transition: 'background-color .15s ease',
                                '&:hover': { backgroundColor: '#F3F6FF' },
                                '&.Mui-focused': { backgroundColor: '#F3F6FF' },
                              },
                            },
                          }}
                        />
                      )}

                      {/* Environment Filter */}
                      <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel sx={{ fontSize: '0.875rem' }}>
                          Filter by Environment
                        </InputLabel>
                        <Select
                          value={selectedEnvironment}
                          onChange={handleEnvironmentFilterChange}
                          label="Filter by Environment"
                          IconComponent={KeyboardArrowDownRounded}
                          MenuProps={{
                            TransitionComponent: Fade,
                            PaperProps: {
                              sx: {
                                mt: 0.5,
                                borderRadius: '10px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
                                overflow: 'hidden',
                              },
                            },
                            MenuListProps: { dense: true, sx: { py: 0.5 } },
                          }}
                          sx={{
                            fontSize: '0.875rem',
                            borderRadius: '10px',
                            bgcolor: '#fff',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#e2e8f0',
                              transition:
                                'border-color .2s ease, box-shadow .2s ease',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#5965A6',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#8E98CD',
                              boxShadow: '0 0 0 2px rgba(89,101,166,0.14)',
                            },
                            '& .MuiSelect-select': {
                              py: 0.75,
                              px: 1.25,
                              fontSize: '0.75rem',
                            },
                            '& .MuiSelect-icon': {
                              color: '#94a3b8',
                              transition: 'transform .2s ease',
                            },
                            '&.Mui-expanded .MuiSelect-icon': {
                              transform: 'rotate(180deg)',
                            },
                            transition:
                              'box-shadow .2s ease, background-color .2s ease, border-color .2s ease',
                          }}
                        >
                          <MenuItem
                            value="all"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedEnvironment === 'all'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            All Environments
                          </MenuItem>
                          {uniqueEnvironments.map((env) => (
                            <MenuItem
                              key={env}
                              value={env}
                              sx={{
                                fontSize: '0.875rem',
                                px: 1.25,
                                py: 0.75,
                                transition: 'background-color .15s ease',
                                '&:hover': { backgroundColor: '#F3F6FF' },
                                '&.Mui-selected, &.Mui-selected:hover': {
                                  backgroundColor: '#EEF2FF',
                                  color: '#5965A6',
                                  fontWeight: 600,
                                },
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 24,
                                  color: '#5965A6',
                                  visibility:
                                    selectedEnvironment === env
                                      ? 'visible'
                                      : 'hidden',
                                }}
                              >
                                <CheckRounded fontSize="small" />
                              </ListItemIcon>
                              {env}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Created At Filter */}
                      <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel sx={{ fontSize: '0.875rem' }}>
                          Filter by Created At
                        </InputLabel>
                        <Select
                          value={selectedCreatedAt}
                          onChange={handleCreatedAtFilterChange}
                          label="Filter by Created At"
                          IconComponent={KeyboardArrowDownRounded}
                          MenuProps={{
                            TransitionComponent: Fade,
                            PaperProps: {
                              sx: {
                                mt: 0.5,
                                borderRadius: '10px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
                                overflow: 'hidden',
                              },
                            },
                            MenuListProps: { dense: true, sx: { py: 0.5 } },
                          }}
                          sx={{
                            fontSize: '0.875rem',
                            borderRadius: '10px',
                            bgcolor: '#fff',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#e2e8f0',
                              transition:
                                'border-color .2s ease, box-shadow .2s ease',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#5965A6',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#8E98CD',
                              boxShadow: '0 0 0 2px rgba(89,101,166,0.14)',
                            },
                            '& .MuiSelect-select': {
                              py: 0.75,
                              px: 1.25,
                              fontSize: '0.75rem',
                            },
                            '& .MuiSelect-icon': {
                              color: '#94a3b8',
                              transition: 'transform .2s ease',
                            },
                            '&.Mui-expanded .MuiSelect-icon': {
                              transform: 'rotate(180deg)',
                            },
                            transition:
                              'box-shadow .2s ease, background-color .2s ease, border-color .2s ease',
                          }}
                        >
                          <MenuItem
                            value="all"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'all'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            All Time
                          </MenuItem>
                          <MenuItem
                            value="today"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'today'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            Today
                          </MenuItem>
                          <MenuItem
                            value="last7days"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'last7days'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            Last 7 Days
                          </MenuItem>
                          <MenuItem
                            value="last30days"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'last30days'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            Last 30 Days
                          </MenuItem>
                          <MenuItem
                            value="last90days"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'last90days'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            Last 90 Days
                          </MenuItem>
                          <MenuItem
                            value="custom"
                            sx={{
                              fontSize: '0.875rem',
                              px: 1.25,
                              py: 0.75,
                              transition: 'background-color .15s ease',
                              '&:hover': { backgroundColor: '#F3F6FF' },
                              '&.Mui-selected, &.Mui-selected:hover': {
                                backgroundColor: '#EEF2FF',
                                color: '#5965A6',
                                fontWeight: 600,
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 24,
                                color: '#5965A6',
                                visibility:
                                  selectedCreatedAt === 'custom'
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <CheckRounded fontSize="small" />
                            </ListItemIcon>
                            Custom Range
                          </MenuItem>
                        </Select>
                      </FormControl>

                      {/* Clear Filters Button */}
                      {(selectedConnector !== 'all' ||
                        selectedOwner !== null ||
                        selectedOrganization !== null ||
                        selectedEnvironment !== 'all' ||
                        selectedCreatedAt !== 'all') && (
                        <Button
                          size="small"
                          onClick={clearAllFilters}
                          sx={{
                            fontSize: '0.75rem',
                            textTransform: 'none',
                            color: '#5965A6',
                            '&:hover': {
                              backgroundColor: '#EEF2FF',
                            },
                          }}
                        >
                          Clear Filters
                        </Button>
                      )}
                    </Box>

                    {/* Right side: Search and View All */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      {/* Search toggle / bar */}
                      <AnimatePresence initial={false}>
                        {searchOpen ? (
                          <motion.div
                            key="searchbar"
                            initial={{ width: 0, opacity: 0 }}
                            animate={{ width: 280, opacity: 1 }}
                            exit={{ width: 0, opacity: 0 }}
                            transition={{ type: 'tween', duration: 0.25 }}
                          >
                            <TextField
                              autoFocus
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search connections…"
                              size="small"
                              fullWidth
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon
                                      fontSize="small"
                                      sx={{ color: '#6B7280' }}
                                    />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSearch('');
                                        setSearchOpen(false);
                                      }}
                                      edge="end"
                                    >
                                      <CloseRounded sx={{ fontSize: 18 }} />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  height: 34,
                                  borderRadius: '8px',
                                  background: '#F8FAFC',
                                  fontSize: '0.75rem',
                                },
                              }}
                            />
                          </motion.div>
                        ) : (
                          <motion.div
                            key="searchicon"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                          >
                            <Tooltip title="Search connections">
                              <IconButton
                                onClick={() => setSearchOpen(true)}
                                size="small"
                                sx={{
                                  border: '1px solid rgba(79, 172, 254, 0.2)',
                                  background: '#EEF2FF',
                                  color: '#5965A6',
                                  boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                  transition:
                                    'transform .18s cubic-bezier(.2,.8,.2,1), box-shadow .2s ease, background-color .2s ease',
                                  willChange: 'transform, box-shadow',
                                  '&:hover': {
                                    background: '#E5E9FF',
                                    transform: 'translateY(-1px) scale(1.02)',
                                    boxShadow: '0 6px 16px rgba(0,0,0,0.16)',
                                  },
                                  '&:active': {
                                    transform: 'translateY(0) scale(.99)',
                                    boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
                                  },
                                  '&:focus-visible': {
                                    outline: 'none',
                                    boxShadow:
                                      '0 0 0 3px rgba(89,101,166,0.35)',
                                  },
                                }}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                          </motion.div>
                        )}
                      </AnimatePresence>
                      {/* Toggle Button */}
                      {filteredConnections.length > 10 && (
                        <motion.div
                          whileTap={{ scale: 0.95 }}
                          onClick={() => setShowAll(!showAll)}
                        >
                          <Typography
                            sx={{
                              fontSize: '0.75rem',
                              fontWeight: 600,
                              color: '#5965A6',
                              cursor: 'pointer',
                              px: 2,
                              py: 1,
                              borderRadius: '8px',
                              border: '1px solid rgba(79, 172, 254, 0.2)',
                              background: '#EEF2FF',
                              userSelect: 'none',
                              boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                              transition:
                                'box-shadow 200ms ease, outline-color 200ms ease',
                              willChange: 'box-shadow',
                              '&:hover': {
                                boxShadow: '0 6px 16px rgba(0,0,0,0.16)',
                              },
                              '&:active': {
                                boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
                              },
                              '&:focus-visible': {
                                outline: 'none',
                                boxShadow: '0 0 0 3px rgba(89,101,166,0.35)',
                              },
                            }}
                          >
                            {showAll
                              ? 'View Less'
                              : `View All (${filteredConnections.length})`}
                          </Typography>
                        </motion.div>
                      )}
                    </Box>
                  </Box>

                  {/* Custom Date Range Picker (shown when Custom Range is selected) */}
                  {selectedCreatedAt === 'custom' && (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        flexWrap: 'wrap',
                      }}
                    >
                      <TextField
                        size="small"
                        label="Start Date"
                        type="date"
                        value={customDateRange.start}
                        onChange={(e) =>
                          setCustomDateRange({
                            ...customDateRange,
                            start: e.target.value,
                          })
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          minWidth: 180,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            fontSize: '0.875rem',
                          },
                        }}
                      />
                      <TextField
                        size="small"
                        label="End Date"
                        type="date"
                        value={customDateRange.end}
                        onChange={(e) =>
                          setCustomDateRange({
                            ...customDateRange,
                            end: e.target.value,
                          })
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          minWidth: 180,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            fontSize: '0.875rem',
                          },
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </motion.div>

            <TableContainer
              sx={{ backgroundColor: '#ffffff', overflow: 'hidden' }}
            >
              <Table
                size="small"
                sx={{
                  width: '100%',
                  '& .MuiTableCell-root': {
                    py: 0.7,
                    px: 2,
                    borderBottom: '1px solid #e5e7eb',
                  },
                  '& thead .MuiTableCell-root': { py: 0.5, px: 1.25 },
                  '& .MuiTableRow-root': { height: 44 },
                }}
              >
                <TableHead sx={{ backgroundColor: '#5965A6' }}>
                  <TableRow
                    sx={{
                      '&:hover': {
                        backgroundColor: '#4C5B9A',
                      },
                      transition: 'background-color 0.2s ease',
                    }}
                  >
                    <TableCell
                      sx={{
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        py: 1,
                        px: 2,
                        color: '#ffffff',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        borderBottom: '1px solid #E5E7EB',
                        width: '60px',
                      }}
                    >
                      Sr No
                    </TableCell>
                    {/* Cache bust - rollback complete */}
                    {/* Sortable headers */}
                    {[
                      { label: 'Connection Name', key: 'name' },
                      { label: 'Environment', key: 'environment' },
                      { label: 'Created At', key: 'createdAt' },
                      ...(isAdmin || isSuperAdmin
                        ? [{ label: 'Owner', key: 'userName' }]
                        : []),
                      ...(isSuperAdmin
                        ? [{ label: 'Organization', key: 'orgName' }]
                        : []),
                      { label: 'Connectors', key: 'connector' },
                    ].map((header) => (
                      <TableCell
                        key={header.key}
                        onClick={() => handleSort(header.key)}
                        sx={{
                          fontSize: '0.75rem',
                          fontWeight: 500,
                          py: 1,
                          px: 2,
                          color: '#ffffff',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          borderBottom: '1px solid #E5E7EB',
                          cursor: 'pointer',
                          userSelect: 'none',
                          position: 'relative',
                          '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            transition: 'background-color 0.2s ease',
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          {header.label}
                          {sortConfig.column === header.key &&
                            sortConfig.direction === 'asc' && (
                              <ArrowUpwardIcon
                                sx={{ fontSize: '0.875rem', ml: 0.5 }}
                              />
                            )}
                          {sortConfig.column === header.key &&
                            sortConfig.direction === 'desc' && (
                              <ArrowDownwardIcon
                                sx={{ fontSize: '0.875rem', ml: 0.5 }}
                              />
                            )}
                          {(!sortConfig.column ||
                            sortConfig.column !== header.key) && (
                            <UnfoldMoreIcon
                              sx={{
                                fontSize: '0.875rem',
                                ml: 0.5,
                                opacity: 0.5,
                              }}
                            />
                          )}
                        </Box>
                      </TableCell>
                    ))}

                    {/* Actions header - not sortable */}
                    <TableCell
                      sx={{
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        py: 1,
                        px: 2,
                        color: '#ffffff',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        borderBottom: '1px solid #E5E7EB',
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    [...Array(5)].map((_, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Skeleton
                            variant="rectangular"
                            width={20}
                            height={20}
                          />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={80} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={80} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={120} />
                        </TableCell>
                        {(isAdmin || isSuperAdmin) && (
                          <TableCell>
                            <Skeleton variant="text" width={100} />
                          </TableCell>
                        )}
                        {isSuperAdmin && (
                          <TableCell>
                            <Skeleton variant="text" width={100} />
                          </TableCell>
                        )}
                        <TableCell>
                          <Skeleton variant="text" width={100} />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Skeleton
                              variant="circular"
                              width={32}
                              height={32}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : displayedRows.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={
                          6 +
                          (isAdmin || isSuperAdmin ? 1 : 0) +
                          (isSuperAdmin ? 1 : 0)
                        }
                        align="center"
                        sx={{ py: 4 }}
                      >
                        <motion.div
                          initial={{ opacity: 0, scale: 0.9 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.3 }}
                        >
                          <Typography
                            sx={{
                              color: '#64748b',
                              fontSize: '0.95rem',
                              mb: 1,
                            }}
                          >
                            No connections found.
                          </Typography>
                          <Typography
                            sx={{
                              color: '#94a3b8',
                              fontSize: '0.85rem',
                            }}
                          >
                            Click &quot;Add New Connection&quot; to get started.
                          </Typography>
                        </motion.div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <AnimatePresence>
                      {displayedRows.map((conn, index) => {
                        // Function to get connector icon
                        const getConnectorIcon = (connector) => {
                          const name = connector?.toLowerCase() || '';
                          if (name.includes('salesforce')) return salesForce;
                          if (name.includes('sql') || name.includes('mysql'))
                            return mySql;
                          if (name.includes('oracle')) return oracle;
                          if (name.includes('hubspot')) return hubspot;
                          if (name.includes('github')) return github;
                          if (name.includes('jira')) return Jira;
                          return null;
                        };

                        return (
                          <TableRow
                            key={conn.id}
                            component={motion.tr}
                            custom={index}
                            variants={rowVariants}
                            initial="hidden"
                            animate="visible"
                            sx={{
                              borderBottom: '1px solid #F3F4F6',
                              backgroundColor:
                                index % 2 === 1 ? '#F3F5F7' : '#ffffff',
                              '&:hover': {
                                backgroundColor:
                                  index % 2 === 1 ? '#71B9FF40' : '#71B9FF40',
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                py: 1,
                                px: 2,
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                color: '#6b7280',
                                verticalAlign: 'middle',
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell sx={{ py: 1, px: 2 }}>
                              <Tooltip title={conn.name}>
                                <Box
                                  component="span"
                                  sx={{
                                    display: 'inline-block',
                                    maxWidth: { xs: '26ch', sm: '34ch' },
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    transition:
                                      'transform .15s ease, background-color .15s ease',
                                    transformOrigin: 'left center',
                                    '&:hover': {
                                      transform: 'scale(1.02)',
                                      cursor: 'pointer',
                                    },
                                  }}
                                >
                                  {conn.name}
                                </Box>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              sx={{
                                py: 1,
                                px: 2,
                                fontSize: '0.875rem',
                                color: '#6b7280',
                                fontWeight: 400,
                                verticalAlign: 'middle',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'inline-block',
                                  px: 2,
                                  py: 0.25,
                                  borderRadius: '8px',
                                  fontSize: '0.75rem',
                                  fontWeight: 700,
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.025em',
                                  color: '#5965A6',
                                }}
                              >
                                {conn.environment}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{
                                py: 1,
                                px: 2,
                                fontSize: '0.875rem',
                                color: '#6b7280',
                                fontWeight: 400,
                                verticalAlign: 'middle',
                              }}
                            >
                              {conn.createdDate}
                            </TableCell>
                            {(isAdmin || isSuperAdmin) && (
                              <TableCell
                                sx={{
                                  py: 1,
                                  px: 2,
                                  fontSize: '0.875rem',
                                  color: '#6b7280',
                                  fontWeight: 400,
                                  verticalAlign: 'middle',
                                }}
                              >
                                {conn.userName || 'N/A'}
                              </TableCell>
                            )}
                            {isSuperAdmin && (
                              <TableCell
                                sx={{
                                  py: 1,
                                  px: 2,
                                  fontSize: '0.875rem',
                                  color: '#6b7280',
                                  fontWeight: 400,
                                  verticalAlign: 'middle',
                                }}
                              >
                                {conn.orgName || 'N/A'}
                              </TableCell>
                            )}
                            <TableCell
                              sx={{
                                py: 1,
                                px: 2,
                                fontSize: '0.875rem',
                                color: '#6b7280',
                                fontWeight: 400,
                                verticalAlign: 'middle',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                }}
                              >
                                {getConnectorIcon(conn.connector) && (
                                  <img
                                    src={getConnectorIcon(conn.connector)}
                                    alt={conn.connector}
                                    style={{ width: 20, height: 20 }}
                                  />
                                )}
                                {conn.connector}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{
                                py: 1,
                                px: 2,
                                verticalAlign: 'middle',
                              }}
                            >
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <motion.div whileTap={{ scale: 0.95 }}>
                                  <Tooltip title="Test Connection">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        //  Open CreateNewConnections in TEST mode (read-only)
                                        navigate(
                                          `/createconnections?conn_id=${conn.id}&mode=test`,
                                        );
                                      }}
                                      sx={{
                                        color: '#6b7280',
                                        padding: '6px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      <LanOutlinedIcon
                                        sx={{
                                          width: 22,
                                          height: 22,
                                          color: '#5965A6',
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </motion.div>

                                <motion.div whileTap={{ scale: 0.95 }}>
                                  <Tooltip title="Edit Connection">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPendingEdit(conn); // ← store row's connection
                                        setEditReauthOpen(true); // ← open reauth dialog
                                      }}
                                      sx={{
                                        color: '#6b7280',
                                        padding: '6px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Edit"
                                        style={{ width: 22, height: 22 }}
                                      />
                                    </IconButton>
                                  </Tooltip>

                                  <EditConnectionReauthDialog
                                    open={editReauthOpen}
                                    connection={pendingEdit}
                                    onClose={() => {
                                      setEditReauthOpen(false);
                                      setPendingEdit(null);
                                    }}
                                    onVerified={() => {
                                      if (pendingEdit?.id)
                                        navigate(
                                          `/createconnections?conn_id=${pendingEdit.id}`,
                                        );
                                    }}
                                  />
                                </motion.div>
                                <motion.div whileTap={{ scale: 0.95 }}>
                                  <Tooltip title="Delete Connection">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPendingDelete(conn);
                                        setDeleteOpen(true);
                                      }}
                                      sx={{
                                        color: '#6b7280',
                                        padding: '6px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      <img
                                        src={DeleteIcon}
                                        alt="Delete"
                                        style={{ width: 22, height: 22 }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </motion.div>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </AnimatePresence>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </motion.div>
      </Box>
      <DeleteConnectionDialog
        open={deleteOpen}
        connection={pendingDelete}
        onClose={() => {
          setDeleteOpen(false);
          setPendingDelete(null);
        }}
        onConfirm={async (id) => {
          await handleDelete(id);
          setDeleteOpen(false);
          setPendingDelete(null);
        }}
      />
    </Box>
  );
};

export default MyConnections;
